import axios from 'axios'
import jsonBig from 'json-bigint'
import { Message } from 'element-ui'
import store from '@/store'
import { getToken } from '@/utils/auth'
// import NProgress from 'nprogress' // progress bar
// import 'nprogress/nprogress.css' // progress bar style
import { Loading } from 'element-ui'

// create an axios instance
const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API, // url = base url + request url
  // withCredentials: true, // send cookies when cross-domain requests
  timeout: 1000 * 60 * 5, // request timeout

  // transformResponse 允许自定义原始的响应数据（字符串）
  transformResponse: [function(data) {
    try {
      // 如果转换成功则返回转换的数据结果
      return jsonBig.parse(data)
    } catch (err) {
      // 如果转换失败，原样返回
      return JSON.parse(data)
    }
  }]
})

// request interceptor
service.interceptors.request.use(
  config => {
    if (config.callId) {
      if (config.callId === 'fullLoading') {
        window.fullLoading = Loading.service({
          fullscreen: true,
          'customClass': 'full-loading',
          // text: '加载...',
          background: 'rgba(255, 255, 255, 0.0)'
        })
      } else {
        store.dispatch('app/addLoading', config.callId)
      }
    }
    console.log(store.state.app)
    console.log(config)
    // do something before request is sent

    // if (store.getters.token) {
    // let each request carry token
    // ['X-Token'] is a custom headers key
    // please modify it according to the actual situation
    // config.headers['X-Token'] = getToken()
    const token = getToken() // store.getters.token
    config.headers['Authorization'] = `Bearer ${token}`
    // }
    return config
  },
  error => {
    // do something with request error
    if (error.config.callId) {
      if (error.config.callId === 'fullLoading') {
        window.fullLoading.close()
      } else {
        store.dispatch('app/rmLoading', error.config.callId)
      }
    }

    console.log(error) // for debug
    // return Promise.reject(error)
    throw error
  }
)

// response interceptor
service.interceptors.response.use(
  /**
   * If you want to get http information such as headers or status
   * Please return  response => response
  */

  /**
   * Determine the request status by custom code
   * Here is just an example
   * You can also judge the status by HTTP Status Code
   */

  /*
    200: OK。一切正常。
    201: 响应 POST 请求时成功创建一个资源。Location header 包含的URL指向新创建的资源。
    204: 该请求被成功处理，响应不包含正文内容 (类似 DELETE 请求)。
    304: 资源没有被修改。可以使用缓存的版本。
    400: 错误的请求。可能通过用户方面的多种原因引起的，例如在请求体内有无效的JSON 数据，无效的操作参数，等等。
    401: 验证失败。
    403: 已经经过身份验证的用户不允许访问指定的 API 末端。
    404: 所请求的资源不存在。
    405: 不被允许的方法。 请检查 Allow header 允许的HTTP方法。
    415: 不支持的媒体类型。 所请求的内容类型或版本号是无效的。
    422: 数据验证失败 (例如，响应一个 POST 请求)。 请检查响应体内详细的错误消息。
    429: 请求过多。 由于限速请求被拒绝。
    500: 内部服务器错误。 这可能是由于内部程序错误引起的。
  */

  response => {
    if (response.config.callId) {
      if (response.config.callId === 'fullLoading') {
        window.fullLoading.close()
      } else {
        store.dispatch('app/rmLoading', response.config.callId)
      }
    }
    const data = response.data
    console.log(`请求: ${response.config.baseURL}${response.config.url}`)
    console.log(`参数: `, response.config.data)
    console.log(`返回: `, response)

    // if the custom status is not 200, it is judged as an error.
    if (data.status !== 200) {
      // alert(`请求: ${response.config.baseURL}${response.config.url}`)
      // alert(data.message || 'Error')
      // 未登录
      if (data.status === 401) {
        // 登录失败
        if (response.config.callId === 'login') {
          Message({
            message: data.message || 'Error',
            type: 'error',
            center: true,
            duration: 3 * 1000
          })
          // alert(data.message || 'Error')
          throw new Error(data.message || 'Error')
        }
        // 未登录/登录失效
        // to re-login
        store.dispatch('user/resetToken')
        location.reload()
      } else if (data.status === 422) {
        // 表单验证错误
        if (response.config.callArgs.showError !== 'silent') {
          Message({
            message: data.body[0].message || 'Error',
            type: 'error',
            center: true
          })
        }
        // 上层可能需要处理，data往上传递
        // eslint-disable-next-line no-throw-literal
        throw {
          data: data,
          error: new Error(data.message || 'Error')
        }
      } else {
        // showError:
        // silent - 不显示错误
        // page - 以页面方式显示
        // default - 以toast方式显示
        if (response.config.callArgs.showError === 'page') {
          const title = `${data.message || '出错了'}`
          // alert(title)
          location.replace(process.env.VUE_APP_WEBAPP_BASE_URL + `/result?type=error&title=${title}`)
          throw new Error(data.message || 'Error') // 终止调用者后续程序运行
        } else {
          if (response.config.callArgs.showError !== 'silent') { // orgView 无权限时不显示错误信息
            Message({
              message: data.message || 'Error',
              type: 'error',
              center: true,
              duration: 3 * 1000
            })
            // alert(data.message || 'Error')
          }
          throw new Error(data.message || 'Error')
          // return Promise.reject(data.message || 'Error')
        }
      }
    }
    return data.body
  },
  error => {
    if (error.config.callId) {
      if (error.config.callId === 'fullLoading') {
        window.fullLoading.close()
      } else {
        store.dispatch('app/rmLoading', error.config.callId)
      }
    }
    console.log('err' + error) // for debug
    Message({
      message: error.message,
      type: 'error',
      center: true,
      duration: 3 * 1000
    })
    alert(error.message || 'Error')
    throw error
  }
)

export default service
